import React from 'react';
import { View, Text, Image } from '@react-pdf/renderer';
import { pdfStyles } from '../PDFStyles';

interface HeaderSectionProps {
  forecast: any;
  formData: {
    content: string;
    platform: string;
    sender: string;
    sector: string;
  };
  simulation: any;
  user?: {
    firstName?: string;
    lastName?: string;
    email?: string;
  };
}

// Helper function to format dates
const formatDate = (dateString?: string) => {
  if (!dateString) return new Date().toLocaleDateString();
  try {
    return new Date(dateString).toLocaleDateString();
  } catch {
    return new Date().toLocaleDateString();
  }
};

// Helper function to capitalize first letter
const capitalizeFirstLetter = (string?: string | null) => {
  if (!string || typeof string !== 'string') return '';
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const HeaderSection: React.FC<HeaderSectionProps> = ({ 
  forecast, 
  formData, 
  simulation, 
  user 
}) => {
  const getUserDisplayName = () => {
    if (user?.firstName && user?.lastName) {
      return `${user.firstName} ${user.lastName}`;
    }
    if (user?.firstName) {
      return user.firstName;
    }
    if (user?.email) {
      return user.email;
    }
    return 'Anonymous';
  };

  return (
    <View style={pdfStyles.pdfHeader}>
      <View style={pdfStyles.headerLeft}>
        <Image 
          src="/images/WaveScoopLogoColor.png" 
          style={pdfStyles.headerLogo}
        />
        <Text style={pdfStyles.headerBrand}>WaveScoop</Text>
      </View>
      <View style={pdfStyles.headerRight}>
        <Text style={pdfStyles.headerTitle}>
          {capitalizeFirstLetter(forecast?.eventType || 'Analysis')} - {formData.sender || 'Anonymous'}
        </Text>
        <Text style={pdfStyles.headerInfoRow}>Platform: {formData.platform || 'Unknown'}</Text>
        <Text style={pdfStyles.headerInfoRow}>Created by: {getUserDisplayName()}</Text>
        <Text style={pdfStyles.headerInfoRow}>Created Date: {formatDate(simulation?.createdAt)}</Text>
      </View>
    </View>
  );
};